import { createAction, props } from "@ngrx/store";
import ISkillAlias from "@skills-app/models/skillAlias";

const prefix = "[Skill Alias API]";

export const populateSkillAliases = createAction(
  `${prefix} Populate Skill Aliases`,
  props<{ skillAliases: ISkillAlias[] }>(),
);
export const skillAliasDeleted = createAction(`${prefix} Skill Alias Deleted`);
export const skillAliasesSaved = createAction(`${prefix} Skill Aliases Saved`);
